import { arrayOf, bool, func, node, object, oneOfType, shape, string } from 'prop-types';

const childrenPropTypes = oneOfType([
    node,
    arrayOf(node)
]);

export const i18nPropType = shape({
    t: func.isRequired
});

export const exposedTranslationButtonProps = {
    toggled: bool,
    loading: bool,
    onClick: func,
    sourceInfo: object,
    disclaimerClassName: string
};

export const baseTranslationButtonProps = {
    ...exposedTranslationButtonProps,
    i18n: i18nPropType,
    showGoogleMTExperience: bool
};

export const translationButtonProps = {
    ...baseTranslationButtonProps,
    withDisclaimer: bool,
    className: string,
    children: childrenPropTypes
};
